import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gadchiroli-district-badminton-championship',
  templateUrl: './gadchiroli-district-badminton-championship.component.html',
  styleUrls: ['./gadchiroli-district-badminton-championship.component.scss']
})
export class GadchiroliDistrictBadmintonChampionshipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
